import { Component, Input, OnChanges } from "@angular/core";
import { baseLocationToString } from "src/services/subscription/base-locations.enum";
import { tryParseDate } from "src/services/utils/timestamp.utils";
import { Subscription } from "src/services/subscription/subscription";
import { Order } from "src/services/order/order.interface";
import { PendingOrder } from "src/services/pending-order/pending-order.interface";

@Component({
  selector: "rc-order-user-info",
  template: `
    @if (!subscriptions && !order) {
      <ion-row class="full-height ion-align-items-center">
        <ion-col class="ion-text-center">
          <ion-icon class="user-info-placeholder" name="people-outline" color="medium"></ion-icon>
        </ion-col>
      </ion-row>
    }

    @if (tryParseDate(order?.createdAt); as parsedDate) {
      <ion-row class="user-info">
        <ion-text>Created: {{ parsedDate | date: "short" }}</ion-text>
      </ion-row>
    }
    <ion-row class="user-info">
      @if (subscriptions) {
        <ion-text>Base: {{ fromEnumToDisplayString(subscription?.baseLocation) }}</ion-text>
      }
      @if (!subscriptions && order) {
        <ion-text>Base: No subscription</ion-text>
      }
    </ion-row>
    <ion-row class="user-info">
      @if (subscriptions) {
        <ion-text>Plan: {{ displaySubscriptionType }}</ion-text>
      }
      @if (!subscriptions && order) {
        <ion-text>Plan: No subscription</ion-text>
      }
    </ion-row>
  `,
  styleUrls: ["./full-order-card.component.scss"],
  standalone: false,
})
export class OrderUserInfoComponent implements OnChanges {
  @Input() order: Order | PendingOrder;
  @Input() subscriptions: Subscription[];

  public displaySubscriptionType: string;
  public subscription: Subscription;

  constructor() {}

  public ngOnChanges() {
    this.processSubscriptions();
  }

  public readonly tryParseDate = tryParseDate;
  public readonly fromEnumToDisplayString = baseLocationToString;

  private processSubscriptions(): void {
    if (!this.subscriptions || this.subscriptions.length === 0) {
      this.displaySubscriptionType = "No subscription";
      return;
    }

    this.subscription = this.subscriptions[0];

    if (this.subscriptions.length > 1) {
      this.displaySubscriptionType = `${this.subscription.subscriptionType} + ${this.subscriptions.length - 1} others`;
    } else {
      this.displaySubscriptionType = this.subscription.subscriptionType;
    }
  }
}
